import { render, staticRenderFns } from "./DocumentRuleHeader.vue?vue&type=template&id=d287a082&scoped=true&"
import script from "./DocumentRuleHeader.vue?vue&type=script&lang=js&"
export * from "./DocumentRuleHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d287a082",
  null
  
)

export default component.exports